import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  user?: any;
  onLogout?: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, user, onLogout }) => {
  const { t } = useTranslation();
  return (
    <div className="layout">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="header-left">
              <Link to="/client/dashboard" className="logo">
                <span className="logo-icon">🚀</span>
                <span className="logo-text">BoardTraff</span>
              </Link>
              <Link to="/client/call-check" className="call-check-link" style={{ marginLeft: 16, color: '#000' }}>
                Проверка звонка
              </Link>
            </div>

            <div className="header-right">
              {user && (
                <div className="user-menu">
                  <div className="user-info">
                    <div className="user-details">
                    </div>
                  </div>
                  {onLogout && (
                    <button onClick={onLogout} className="btn btn-ghost btn-sm">
                      {t('logout')}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main">
        <div className="container p-0">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout; 